import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { Dialog } from 'primereact/dialog';
import COInlineMessage from '@components/ringil3/COInlineMessage/COInlineMessage.tsx';
import SvgGrayInfo from '@components/ringil3/icons/GrayInfo.tsx';
import RingilButton from '@components/ringil3/Buttons/RingilButton.tsx';
import SvgDelete from '@icons/delete-trash.svg?react';

interface ComponentProps {
  visible: boolean;
  onHide: () => void;
  onConfirm: () => void;
  dataTestId?: string;
}

const ConfirmRejectPartnerDialog: React.FC<ComponentProps> = ({ visible, onHide, onConfirm, dataTestId }) => {
  const { tr } = useTranslationLgs();


  return (
    <>
      {/* @ts-ignore*/}
      <Dialog
        visible={visible}
        onHide={onHide}
        style={{ width: '450px' }}
        header={tr('ConfirmRejectPartnerDialog.title', 'Really delete?')}
      >

        <div>
          <div className="mb-6">
            <COInlineMessage variant={'warning'} icon={<SvgGrayInfo />}>
              {tr('ConfirmRejectPartnerDialog.warning', 'Warning: Deleting cannot be undone.')}
            </COInlineMessage>
          </div>

          <div className="mb-6">
            <RingilButton
              icon={<SvgDelete />}
              label={tr('ConfirmRejectPartnerDialog.confirm', 'Delete')}
              onClick={onConfirm}
              mode={'filled'}
              dataTestId={dataTestId}
            />
            <RingilButton
              label={tr('ConfirmRejectPartnerDialog.cancel', 'Cancel')}
              onClick={onHide}
              mode={'text-only'}
              dataTestId={dataTestId}

            />
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default ConfirmRejectPartnerDialog;
